import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { CODE_TO_URL } from "../lib/i18nRouter";
import { POLICY_LINKS } from "../pages/Policies";
import { useConsent } from "../context/ConsentContext";
import TX from "./TX";

export const Footer = () => {
  const { lang } = useLang();
  const slug = CODE_TO_URL[lang] || "en";
  const lp = (path) => `/${slug}${path === "/" ? "" : path}`;
  const { openManage } = useConsent();

  return (
    <footer data-testid="site-footer" className="bg-noir border-t border-white/10 mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <picture>
            <source srcSet="/opikjewels-logo.webp" type="image/webp" />
            <img
              src="/opikjewels-logo.png"
              alt="OPIKJEWELS — Crafted with passion. Cherished forever."
              className="block h-24 md:h-28 w-auto mb-6 select-none"
              draggable="false"
              width="1024"
              height="671"
            />
          </picture>
          <p className="text-white/50 text-sm leading-relaxed font-light max-w-xs">
            <TX>International gemstone authority. Auction house. Investment portfolio for collectors of singular taste.</TX>
          </p>
        </div>
        <div>
          <div className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5"><TX>Maison</TX></div>
          <ul className="space-y-3 text-white/60 text-sm">
            <li><Link to={lp("/about")}><TX>Heritage</TX></Link></li>
            <li><Link to={lp("/investor-relations")}><TX>Investor Relations</TX></Link></li>
            <li><Link to={lp("/blog")}><TX>Market Insight</TX></Link></li>
            <li><Link to={lp("/contact")}><TX>Contact</TX></Link></li>
          </ul>
        </div>
        <div>
          <div className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5"><TX>Services</TX></div>
          <ul className="space-y-3 text-white/60 text-sm">
            <li><Link to={lp("/concierge")}><TX>Concierge</TX></Link></li>
            <li><Link to={lp("/private-sales")}><TX>Private Sales</TX></Link></li>
            <li><Link to={lp("/sell")}><TX>Sell Your Gemstone</TX></Link></li>
            <li><Link to={lp("/verify")}><TX>Certificate Verify</TX></Link></li>
          </ul>
        </div>
        <div>
          <div className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5"><TX>Trust & Policies</TX></div>
          <ul className="space-y-3 text-white/60 text-sm">
            {POLICY_LINKS.map((p) => (
              <li key={p.key}>
                <Link to={lp(`/${p.path}`)} data-testid={`footer-policy-${p.key}`} className="hover:text-gold transition-colors"><TX>{p.label}</TX></Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pb-12">
        <div className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5"><TX>Headquarters</TX></div>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-white/60 text-sm font-light">
          <li><TX>Jakarta, Indonesia · HQ · Jakarta Gems Center, Pintu Bacan, Jakarta 13320</TX></li>
          <li><TX>Bangkok, Thailand · Trading · Silom Road</TX></li>
          <li>info@opikjewels.com</li>
          <li>
            <a href="https://wa.me/6287781058814" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">
              <TX>WhatsApp</TX> · +62 877 8105 8814
            </a>
          </li>
        </ul>
      </div>
      <div className="border-t border-white/5 py-6 flex flex-col sm:flex-row gap-3 sm:gap-6 items-center justify-center text-white/30 text-[11px] tracking-[0.28em] uppercase font-accent">
        <span>© {new Date().getFullYear()} OPIKJEWELS — <TX>All Rights Reserved</TX></span>
        <button
          type="button"
          data-testid="footer-cookie-settings"
          onClick={openManage}
          className="hover:text-gold transition-colors"
        >
          <TX>Cookie Settings</TX>
        </button>
      </div>
    </footer>
  );
};

export default Footer;
